import { Illustration } from "frontend/canvas-designer-new/integrations/monday-integration-popup/illustration";
import React from "react";
import styles from "./monday-integration-popup.module.css";
import { useAtom, useSetAtom } from "jotai";
import { mondayIntegrationPopupAtom, SidepanelType, sidePanelType } from "state-atoms";
import { saveUserSettingForGanttMondayIntegration } from "elements/gantt/utils";

export const MondayIntegrationPopup = () => {
  const [showMondayIntegrationPopup, setShowMondayIntegrationPopup] = useAtom(mondayIntegrationPopupAtom);
  const setOpenedSidePanel = useSetAtom(sidePanelType);

  return (
    <div className={styles.wrapper}>
      <Illustration />
      <div className={styles.contentWrapper}>
        <div className={styles.title}>Map your monday.com fields to WorkCanvas</div>
        <div className={styles.content}>Optimize your monday.com integration by mapping data fields to WorkCanvas</div>

        <div className={styles.actions}>
          <button
            className={styles.cancelButton}
            onClick={() => {
              saveUserSettingForGanttMondayIntegration(showMondayIntegrationPopup.integrationId, "hide-popup");
              setShowMondayIntegrationPopup({
                isOpen: false,
                selectedResult: "cancel",
                integrationId: undefined,
              });
            }}
          >
            Cancel
          </button>
          <button
            className={styles.mapButton}
            onClick={() => {
              setShowMondayIntegrationPopup({
                isOpen: false,
                selectedResult: "map",
                integrationId: showMondayIntegrationPopup.integrationId,
              });
              setOpenedSidePanel(SidepanelType.integrations);
            }}
          >
            Map data
          </button>
        </div>
      </div>
    </div>
  );
};
